import React from "react";

import CloseReasonCellContent from "../components/CloseReasonCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function closeReason({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.CloseReason,
		(item) => <CloseReasonCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default closeReason;
